import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center gap-2" }
const _hoisted_2 = { style: {"margin-right":"1rem"} }
const _hoisted_3 = { style: {"margin-right":"1rem"} }
const _hoisted_4 = { class: "flex justify-center items-center gap-2" }
const _hoisted_5 = { style: {"margin-right":"1rem"} }
const _hoisted_6 = { class: "flex justify-center items-center gap-2" }

import BaseInput from "../components/BaseInput.vue";
import BaseOutput from "../components/BaseOutput.vue";
import BaseButtons from "../components/BaseButtons.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'velocitaInfusioneCalculator',
  props: {
    peso: {}
  },
  setup(__props: any) {

const props = __props;

let doseInfondere = ref();
let contenutoFiala = ref();
let fialeDiluite = ref();
let volumeFlebo = ref();

let concentrazione = ref("...");
let velocitaInf = ref("...");

let doseInfondereValid = ref("");
let contenutoFialaValid = ref("");
let fialeDiluiteValid = ref("");
let volumeFleboValid = ref("");

function calculator() {
  // Gestione valori in input
  doseInfondere.value = (isNaN(doseInfondere.value) || doseInfondere.value == 0) ? 1 : doseInfondere.value;
  contenutoFiala.value = (isNaN(contenutoFiala.value) || contenutoFiala.value == 0) ? 1 : contenutoFiala.value;
  fialeDiluite.value = (isNaN(fialeDiluite.value) || fialeDiluite.value == 0) ? 1 : fialeDiluite.value;
  volumeFlebo.value = (isNaN(volumeFlebo.value) || volumeFlebo.value == 0) ? 100 : volumeFlebo.value;

  // Controllo calcolo nullo
  concentrazione.value = (contenutoFiala.value * fialeDiluite.value) / volumeFlebo.value;
  concentrazione.value = isNaN(concentrazione.value) ? "..." : concentrazione.value;

  // Controllo calcolo nullo
  velocitaInf.value = Math.round((props.peso * doseInfondere.value * 60) / (concentrazione.value * 1000));
  velocitaInf.value = isNaN(velocitaInf.value) ? "..." : velocitaInf.value;
}

function eraser (field) {
  field.value = "";
}

function resetForm() {
  // Cancellazione valori inseriti
  eraser(doseInfondere);
  eraser(contenutoFiala);
  eraser(fialeDiluite);
  eraser(volumeFlebo);

  // Cancellazione valori calcolati
  concentrazione.value = "...";
  velocitaInf.value = "...";

  // Cancellazione validatori
  eraser(doseInfondereValid);
  eraser(contenutoFialaValid);
  eraser(fialeDiluiteValid);
  eraser(volumeFleboValid);
}

function checkInputValidity(field: string) {
  switch (field) {
    case "doseInfondere":
      if (isNaN(doseInfondere.value) || doseInfondere.value < 1 || doseInfondere.value > 10) {
        doseInfondereValid.value = "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
      } else {
        eraser(doseInfondereValid)
      }
    break;

    case "contenutoFiala":
      if (isNaN(contenutoFiala.value) || contenutoFiala.value < 1 || contenutoFiala.value > 10) {
        contenutoFialaValid.value = "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
      } else {
        eraser(contenutoFialaValid)
      }
    break;

    case "fialeDiluite":
      if (isNaN(fialeDiluite.value) || fialeDiluite.value < 1 || fialeDiluite.value > 10) {
        fialeDiluiteValid.value = "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
      } else {
        eraser(fialeDiluiteValid)
      }
    break;

    case "volumeFlebo":
      if (isNaN(volumeFlebo.value) || volumeFlebo.value < 100 || volumeFlebo.value > 500) {
        volumeFleboValid.value = "Controlla il valore inserito. Il valore deve essere compreso tra 100 e 500.";
      } else {
        eraser(volumeFleboValid)
      }
    break;

    default:
    break;
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseInput, {
          label: (_ctx.$t('Dose da Infondere' + ' (mcg/Kg/min)')),
          type: "number",
          placeholder: "1",
          modelValue: _unref(doseInfondere),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(doseInfondere) ? (doseInfondere).value = $event : doseInfondere = $event)),
          onValidateInput: _cache[1] || (_cache[1] = ($event: any) => (checkInputValidity('doseInfondere'))),
          isInputValid: _unref(doseInfondereValid)
        }, null, 8, ["label", "modelValue", "isInputValid"]),
        _createVNode(BaseInput, {
          label: (_ctx.$t('Contenuto Fiala') + ' (mg)'),
          type: "number",
          placeholder: "1",
          modelValue: _unref(contenutoFiala),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(contenutoFiala) ? (contenutoFiala).value = $event : contenutoFiala = $event)),
          onValidateInput: _cache[3] || (_cache[3] = ($event: any) => (checkInputValidity('contenutoFiala'))),
          isInputValid: _unref(contenutoFialaValid)
        }, null, 8, ["label", "modelValue", "isInputValid"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseInput, {
          label: _ctx.$t('Fiale Diluite'),
          type: "number",
          placeholder: "1",
          modelValue: _unref(fialeDiluite),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(fialeDiluite) ? (fialeDiluite).value = $event : fialeDiluite = $event)),
          onValidateInput: _cache[5] || (_cache[5] = ($event: any) => (checkInputValidity('fialeDiluite'))),
          isInputValid: _unref(fialeDiluiteValid)
        }, null, 8, ["label", "modelValue", "isInputValid"]),
        _createVNode(BaseInput, {
          label: _ctx.$t('Volume Flebo'),
          type: "number",
          placeholder: "100",
          modelValue: _unref(volumeFlebo),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(volumeFlebo) ? (volumeFlebo).value = $event : volumeFlebo = $event)),
          onValidateInput: _cache[7] || (_cache[7] = ($event: any) => (checkInputValidity('volumeFlebo'))),
          isInputValid: _unref(volumeFleboValid)
        }, null, 8, ["label", "modelValue", "isInputValid"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseButtons, {
          onClearForm: resetForm,
          onCalculate: calculator,
          hiddenSalvaButton: ""
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(BaseOutput, {
        class: "flex text-sm basecolor-mr",
        label: _ctx.$t('Concentrazione'),
        key: "number",
        result: _unref(concentrazione),
        unit: "mg/ml"
      }, null, 8, ["label", "result"]),
      _createVNode(BaseOutput, {
        class: "flex text-sm basecolor-mr",
        label: _ctx.$t('Velocità di infusione'),
        key: "number",
        result: _unref(velocitaInf),
        unit: "ml/ora"
      }, null, 8, ["label", "result"])
    ])
  ], 64))
}
}

})